import { Link } from "react-router-dom";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import USPs from "components/USPs";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";

export default function Home() {
  const { DiscoverCTA, resellerCTA, becomeResellerCTA } = brandConfig;
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Acceuil"
        description={`${brandConfig.brandName} est une marque suisse dédiée aux armoires à fusils sécurisées. Découvrez notre gamme grâce aux conseils de nos revendeurs experts et de notre réseau de revendeurs certifiés.`}
      />
      {/* HERO */}
      <section className="hero">
        <div className="hero__inner container">
          {/* Colonne gauche : contenu sur fond blanc */}
          <div className="hero__content">
            <h1>The TresorSafe</h1>
            <p className="hero__lead">
              Marque dédiée aux armoires à fusils sécurisées. Découvrez notre
              gamme et nos revendeurs agréés.
            </p>

            <div className="hero__cta">
              <Link to={DiscoverCTA.path} className="btn">
                {DiscoverCTA.label}
              </Link>
              <Link
                to={resellerCTA.path}
                className="btn btn-secondary btn-ghost"
                aria-label="Trouver un revendeur"
              >
                {resellerCTA.label}
              </Link>
            </div>

            <div className="hero__subcta">
              <Link className="btn btn-ghost" to={becomeResellerCTA.path}>
                {becomeResellerCTA.label}
              </Link>
            </div>
          </div>

          {/* Colonne droite : image produit */}
          <div className="hero__media" aria-hidden="true">
            <picture>
              <source
                srcSet="/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp"
                type="image/webp"
              />
              <img
                className="hero__product"
                src="/assets/tresorsafe-hero.jpg"
                alt=""
                loading="eager"
                decoding="async"
                width={520}
                height={520}
              />
            </picture>
          </div>
        </div>
      </section>

      {/* USPs */}
      <USPs />
    </>
  );
}
